<div class="container">
  <form
    action="{{ returnUrl }}"
    class="paymentWidgets hobex-payment-form"
    data-brands="VISA MASTER AMEX"
  ></form>
</div>
